import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { API } from '../../services/api';
const api = new API();

import { checkAuth } from '../auth/authSlice';

export const fetchUserInfo = createAsyncThunk(
  'user/get',
  async (data, thunkAPI) => {
    try {
      const response = await api.getUserInfo();
      console.log('response', response);

      if(response.status === 'ok' && response.result) {
        return response.result;
      } else {
        return thunkAPI.rejectWithValue(response.messages);
      }
    } catch(e) {
      // System error or status code >= 500
      console.error('ERROR: users/get', e.message);

      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
);

export const saveUserInfo = createAsyncThunk(
  'user/save',
  async (data, thunkAPI) => {
    try {
      const response = await api.updateUser(data);

      if(response.status === 'ok') {
        return response.result;
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      console.error('ERROR: users/save', e.message);

      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
)

const initialState = {
  info: {},
  fetchStatus: 'idle',
  fetchError: null,
  saveStatus: 'idle',
  saveError: null
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearSaveState: (state, action) => {
      state.saveStatus = 'idle';
    }
  },
  extraReducers: {
    [fetchUserInfo.fulfilled]: (state, action) => {
      state.fetchStatus = 'succeeded';
      state.fetchError = null;
      state.loggedIn = true;
      state.info = action.payload;
    },
    [fetchUserInfo.pending]: (state, action) => {
      state.fetchStatus = 'loading';
      state.fetchError = null;
    },
    [fetchUserInfo.rejected]: (state, action) => {
      state.fetchStatus = 'failed';
      state.fetchError = action.payload;
    },

    [checkAuth.fulfilled]: (state, action) => {
      state.info = action.payload;
    },

    [saveUserInfo.fulfilled]: (state, action) => {
      state.saveStatus = 'succeeded';
      state.saveError = null;
      if(action.meta.arg?.firstName) {
        state.info.firstName = action.meta.arg.firstName;
      }
      if(action.meta.arg?.lastName) {
        state.info.lastName = action.meta.arg.lastName;
      }
    },
    [saveUserInfo.pending]: (state, action) => {
      state.saveStatus = 'loading';
      state.saveError = null;
    },
    [saveUserInfo.rejected]: (state, action) => {
      state.saveStatus = 'failed';

      // Contrary to expectations, a valid field is also present in error object.
      // Filter those out
      const errorFields = Object.keys(action.payload.result.errors).filter(field => action.payload.result.errors[field] === false);

      const uiErrorFields = {};

      errorFields.forEach(field => {
        uiErrorFields[field] = true;
      });

      state.saveError = {
        message: action.payload.messages.join(', '),
        fields: uiErrorFields
      };
    },
  }
});

export const { clearSaveState } = userSlice.actions;
export const selectUser = state => state.user;

export default userSlice.reducer;
